import { apiClient } from "../API/axiosInstance";
import { logger } from "../utils/logger";

/**
 * Service class for Actions operations
 */
export class ActionsService {
  static async fetchActions(orgID) {
    if (orgID === undefined || orgID === 0) return [];
    const result = await apiClient.get(`/action/${orgID}`);
    return result.data || [];
  }

  static async fetchAction(actionId) {
    const result = await apiClient.get(`/action/single/${actionId}`);
    return result.data;
  }

  static async fetchActionLogs(organisationId, actionId, startDate, endDate) {
    let url = `/action/${organisationId}/${actionId}/logs`;
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    const result = await apiClient.get(url);
    return result.data || [];
  }

  static async createAction(actionData) {
    const response = await apiClient.post(
      `/action/${actionData.organisation_id}`,
      actionData
    );
    return response;
  }

  static async updateAction(actionId, actionData) {
    const response = await apiClient.put(`/action/${actionId}`, actionData);
    return response;
  }

  static async deleteAction({ actionId }) {
    const response = await apiClient.delete(`/action/${actionId}`);
    return response;
  }

  static async executeAction(actionId) {
    const response = await apiClient.post(`/action/execute/${actionId}`, {});
    return response;
  }

  static async updateActionStatus(actionId, status) {
    const selectedOrganisationID = localStorage.getItem(
      "selectedOrganisationID"
    );
    const response = await apiClient.put(
      `/action/${selectedOrganisationID}/${actionId}/status/`,
      {
        action_status: status ? "true" : "false",
      }
    );
    return response;
  }

  static async deleteSelectedActions(selectedActions) {
    const selectedOrganisationID = localStorage.getItem(
      "selectedOrganisationID"
    );

    try {
      selectedActions.forEach(async (action) => {
        await apiClient.delete(`/action/${selectedOrganisationID}/${action}`);
      });
    } catch (error) {
      logger.warn(error);
    }
  }
}
